import React, { useState } from "react";
// import ReactDOM from 'react-dom';
import "antd/dist/antd.css";
import NotEligible from "./NotEligible";
import { Modal, Button, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons/lib/icons";

export default function ContentModal(props) {
  const { modalVisible, popupContent, setHandelContentModal } = props;

  const handleOk = () => {
    setHandelContentModal(false);
  };

  const handleCancel = () => {
    setHandelContentModal(false);
  };

  return (
    <>
      <Modal
        visible={modalVisible}
        // width="335px"
        onCancel={handleCancel}
        footer={null}
        // bodyStyle={{borderRadius:"10px", height:"254.5px",width:"335px"}}
        centered={true}
        closable={true}
        keyboard={true}
        mask={true}
        maskClosable={true}
        closeIcon={
          <CloseOutlined
            style={{
              fontSize: "7px",
              marginTop: "10px",
            }}
            onOk={handleOk}
            className="modalCloseBtn"
          />
        }
      >
        <p style={{ textAlign: "center" }}>{popupContent?.heading} </p>
        <p style={{ textAlign: "center" }}>{popupContent?.description}</p>
        <div style={{ textAlign: "center" }}>
              <button
                onClick={() => {
                  if(popupContent?.link){
                    window.open(popupContent?.link,"_blank")
                  }
                  handleCancel();
                }}
                style={{
                  width: "90%",
                  fontWeight: "500",
                  backgroundColor: "#6C63FF",
                  border: "none",
                  fontSize: "14px",
                  borderRadius: "5px",
                  color: "#FFFFFF",
                  padding: "5px",
                }}
              >
                Ok, got it.
              </button>
            </div>
      </Modal>
    </>
  );
}
// export default ContentModal;
